export function getExternalReviewsData() {
  return window.ratings?.filter((r) => r.enabled);
}
